import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
import useTheme from '../use-theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  gap: 0,
  fluid: true,
  wrap: 'nowrap',
  justify: 'flex-start',
  align: 'flex-start',
  as: 'div',
  className: ''
};

const Row = ({
  children,
  as,
  gap,
  fluid,
  justify,
  align,
  wrap,
  className,
  ...props
}) => {
  const Component = as;
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Component, { ...props,
    className: _JSXStyle.dynamic([["575978181", [wrap, gap, theme.layout.gap, gap, theme.layout.gap, gap, theme.layout.gap, justify, align]]]) + " " + (props && props.className != null && props.className || `row ${className} ${fluid && 'fluid'}`),
    children: [children, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "575978181",
      dynamic: [wrap, gap, theme.layout.gap, gap, theme.layout.gap, gap, theme.layout.gap, justify, align],
      children: `.row.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:relative;box-sizing:border-box;-webkit-flex-wrap:${wrap};-ms-flex-wrap:${wrap};flex-wrap:${wrap};margin-left:calc(${gap} * ${theme.layout.gap} / 2);margin-right:calc(${gap} * ${theme.layout.gap} / 2);--row-gap:calc(${gap} * ${theme.layout.gap});-webkit-box-pack:${justify};-webkit-justify-content:${justify};-ms-flex-pack:${justify};justify-content:${justify};-webkit-align-items:${align};-webkit-box-align:${align};-ms-flex-align:${align};align-items:${align};}.fluid.__jsx-style-dynamic-selector{width:100%;}`
    })]
  });
};

const MemoRow = /*#__PURE__*/React.memo(Row);
export default withDefaults(MemoRow, defaultProps);